import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

@Component({
    selector: 'rendelo-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatListModule
    ],
    standalone: true
})
export class HomeComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
